export const monthlyComics = {
  // Sidebar
  sidebarLabel: "Monthly Rewards",

  // Header
  headerTitle: "{{month}} Member Rewards",
  headerSubtitleFallback:
    "As a Gold member, you can claim exclusive books each month. Pick one or add them all to your collection.",
  monthPicks: "{{month}} picks",
  bookCount: "{{count}} Books",
  bookCountOne: "{{count}} Book",
  totalViews: "{{value}} views",

  // Section headers
  thisMonthsSelection: "This month's selection",
  noTitlesAvailable: "No titles available for this month yet.",

  // Card actions
  subscribeToClaim: "Subscribe to Claim",
  claimWithGold: "Claim with Gold",
  claim: "Claim",
  claimed: "Claimed",
  startReading: "Start reading",
  continueReading: "Continue reading",

  // Toast messages
  toastClaimSuccess: "Claimed! Enjoy your comic.",
  toastAlreadyOwned: "Already in your library!",
  toastAlreadyClaimed: "Already claimed",

  // Coming next section
  comingIn: "Coming in {{month}}",
  nextBatchSubtitle: "Your next batch of free premium titles.",
  fullRevealComingSoon: "Full reveal coming soon",
  toBeRevealed: "To Be Revealed",
  revealed: "Revealed",

  // Type badges
  typeRelease: "Release",
  typeBundleCount: "Bundle ({{count}})",

  // Image alt text
  upsellCoversAlt: "Comic book covers",

  // Accessibility
  openDetailsAria: "Open details for {{title}}",

  // Error fallback
  claimFailed: "Claim failed. Please try again.",

  // Gold upsell banner
  upsellTitle: "Expand your library with free books every month",
  upsellDescription:
    "Become a Gold Member and get free books every month along with access to over 100,000 comics and manga.",
  upsellCta: "Become a member",
};
